import { Directive, ElementRef, Input, OnChanges, Renderer2, SimpleChanges, inject } from '@angular/core';

@Directive({
  selector: '[zeroLoadingIndicator]',
  standalone: true,
})
export class LoadingIndicatorDirective implements OnChanges {
  @Input() public zeroLoadingIndicator: boolean;
  @Input() public liVariant?: string;
  @Input() public description?: string;

  #loadingDiv?: HTMLElement;

  readonly #renderer = inject(Renderer2);
  readonly #elementRef = inject(ElementRef);

  public ngOnChanges(changes: SimpleChanges): void {
    try {
      if (changes['zeroLoadingIndicator'].currentValue === true) {
        this.#generateLoadingDiv();
        this.#renderer.appendChild(this.#elementRef.nativeElement, this.#loadingDiv);
      } else {
        this.#renderer.removeChild(this.#elementRef.nativeElement, this.#loadingDiv);
      }
      // eslint-disable-next-line no-empty
    } catch (e) {}
  }

  #generateLoadingDiv = (): void => {
    // creating container element for loading indicator
    this.#loadingDiv = this.#renderer.createElement('div');
    this.#renderer.addClass(this.#loadingDiv, 'loading-indicator');
    this.#renderer.addClass(this.#loadingDiv, 'align-items-center');
    this.#renderer.addClass(this.#loadingDiv, 'justify-content-center');
    if (this.liVariant === '1') {
      this.#renderer.addClass(this.#loadingDiv, 'd-flex');
    } else {
      this.#renderer.addClass(this.#loadingDiv, 'row');
    }

    // creating elements for animated loading indicator
    const ellipsisdiv = this.#renderer.createElement('div');
    this.#renderer.addClass(ellipsisdiv, 'lds-ellipsis');
    this.#renderer.appendChild(ellipsisdiv, this.#renderer.createElement('div'));
    this.#renderer.appendChild(ellipsisdiv, this.#renderer.createElement('div'));
    this.#renderer.appendChild(ellipsisdiv, this.#renderer.createElement('div'));
    this.#renderer.appendChild(ellipsisdiv, this.#renderer.createElement('div'));

    this.#renderer.appendChild(this.#loadingDiv, ellipsisdiv);

    if (this.description) {
      const description = this.#renderer.createElement('div');
      this.#renderer.addClass(description, 'description');
      this.#renderer.appendChild(description, this.#renderer.createText(this.description));
      this.#renderer.appendChild(this.#loadingDiv, description);
    }
  };
}
